/** @jsx jsx */
// @ts-check
import { Plural, Trans } from '@lingui/macro';
import { jsx } from 'theme-ui';
import DefaultFacet from '../DefaultFacet/DefaultFacet';
import FacetValue from '../DefaultFacet/FacetValue';

export default function ProductVarietiesFacet({
  allMainVarieties,
  selectedMainVarieties,
  allBlendTypes,
  selectedBlendTypes,
  onToggle,
  onToggleBlendType,
  totalCount,
  count,
  ...rest
}) {
  const singleVariety = allBlendTypes.find(
    ({ value }) => value === 'single variety'
  ) || { count: 0 };
  const blend = allBlendTypes.find(({ value }) => value === 'blend') || {
    count: 0,
  };
  return (
    <DefaultFacet
      multiSelect
      title={
        <Plural
          value={allMainVarieties?.length}
          one="# variety"
          other="# varieties"
        />
      }
      allValues={allMainVarieties}
      selectedValues={selectedMainVarieties}
      onToggle={onToggle}
      totalCount={totalCount}
      count={count}
      {...rest}
    >
      <FacetValue
        count={singleVariety.count}
        isSelected={selectedBlendTypes.includes('single variety')}
        onClick={() =>
          onToggleBlendType(
            'single variety',
            !selectedBlendTypes.includes('single variety')
          )
        }
      >
        <Trans>single variety</Trans>
      </FacetValue>
      <FacetValue
        count={blend.count}
        isSelected={selectedBlendTypes.includes('blend')}
        onClick={() =>
          onToggleBlendType('blend', !selectedBlendTypes.includes('blend'))
        }
      >
        <Trans>blend</Trans>
      </FacetValue>
    </DefaultFacet>
  );
}
